import { View } from 'react-native';
import { QuaternaryOnDarkButton } from 'src/editor-v3/components/buttons/quaternary-on-dark-button/QuaternaryOnDarkButton';
import { BUTTON_SIZES, BUTTON_TYPES } from 'src/editor-v3/components/buttons/button/Button.constants';
import { styles } from './PickerSourceButton.styles';
import useResponsiveScreen from 'src/hooks/useResponsiveScreen';
import { PickerSourceProps } from './PickerSourceButton.types';
import { mergeStyles } from 'src/_shared/utils/mergeStyles';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/contexts/StoreContext';
import { ICON_NAMES } from '@photosi/rn-components/icon/icon.helper';
import { SELECTED_MENU_ITEMS } from 'src/store/_models/dynamic-modal-layer/dynamicModalLayer.constants';

const SOURCE_ICON_NAMES: Record<SELECTED_MENU_ITEMS, ICON_NAMES> = {
  [SELECTED_MENU_ITEMS.Computer]: ICON_NAMES.Pc,
  [SELECTED_MENU_ITEMS.GooglePhoto]: ICON_NAMES.GooglePhoto,
  [SELECTED_MENU_ITEMS.Gallery]: ICON_NAMES.PhotoAlbum,
  [SELECTED_MENU_ITEMS.Smartphone]: ICON_NAMES.Smartphone2,
  [SELECTED_MENU_ITEMS.FamilyFriends]: ICON_NAMES.People2,
  [SELECTED_MENU_ITEMS.Add]: ICON_NAMES.Plus,
};

export const PickerSourceButton = observer(
  ({
    source,
    isSelected,
    style,
    innerStyle,
    textStyle,
    iconStyle,
    buttonSelectedStyle,
    pickerStyle,
    ...buttonProps
  }: PickerSourceProps) => {
    const { i18n } = useStore();
    const { isDesktop } = useResponsiveScreen();

    return (
      <View>
        <QuaternaryOnDarkButton
          {...buttonProps}
          type={BUTTON_TYPES.ICON_LEFT}
          iconName={SOURCE_ICON_NAMES[source]}
          style={mergeStyles(
            isDesktop ? styles.buttonDesktop : styles.buttonMobile,
            style,
            isSelected && mergeStyles(styles.buttonSelected, buttonSelectedStyle),
          )}
          innerStyle={mergeStyles(isDesktop ? styles.buttonInnerDesktop : styles.buttonInnerMobile, innerStyle)}
          // textStyle={mergeStyles(isDesktop ? styles.text : styles.textMobile, textStyle)}
          iconStyle={mergeStyles(pickerStyle, iconStyle)}
          accessible={true}
          accessibilityLabel={i18n.t(`actions:open_x`, { x: i18n.t(`upload:${source}`) })}
          accessibilityRole="button"
          size={BUTTON_SIZES.REGULAR}
        />
      </View>
    );
  },
);
